import { render, staticRenderFns } from "./ac-signature-pad.vue?vue&type=template&id=1dcbbe94&"
import script from "./ac-signature-pad.vue?vue&type=script&lang=js&"
export * from "./ac-signature-pad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports